export default __webpack_public_path__ + "static/media/slider verticle line.5e9d2422.svg";